import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { FormularioAtendimentoList } from '../../avaliacoes-pendentes-list/core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { avaliacoesColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const AvaliacoesTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => avaliacoesColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhuma avaliação encontrada'
      description='Revise o paciente, o protocolo, a instituição ou a situação.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhuma avaliação registrada'
      description='As avaliações respondidas nos atendimentos aparecem aqui.'
    />
  )

  return (
    <CustomTable<FormularioAtendimentoList>
      id='kt_table_avaliacoes'
      ariaLabel='Avaliações'
      itemLabel={{ singular: 'avaliação', plural: 'avaliações' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.some((s) => s.formularioAtendimentoId === row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
